import { render, staticRenderFns } from "./CompanyRoleQermission.vue?vue&type=template&id=0d93d708&scoped=true&"
import script from "./CompanyRoleQermission.vue?vue&type=script&lang=js&"
export * from "./CompanyRoleQermission.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRoleQermission.vue?vue&type=style&index=0&id=0d93d708&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d93d708",
  null
  
)

export default component.exports